import {createSlice} from "@reduxjs/toolkit";

const slice = createSlice({
        name: "ProductListingFilterBoxActiveSelection",
        initialState: {},
        reducers: {
            loadData: {
                reducer: (state, action) => {
                    state = action.payload.data;
                    return state;
                },
            },
            updateSmartly: {
                reducer: (state, action) => {
                    if (action.payload.status === true) {
                        state[action.payload.selection.slug] = action.payload.selection;
                    }
                    if (action.payload.status === false) {
                        delete state[action.payload.selection.slug];
                    }
                },
            }
        }
    })
;

export let {loadData, updateSmartly} = slice.actions;

export default slice.reducer;
